/**
 * SEO 配置 - chat (ภาษาไทย)
 */

export default {
    chat: {
        title: 'AI แชท - ผู้ช่วยหลายโมเดล | WeryAI',
        description:
            'แชทกับโมเดล AI ชั้นนำบน WeryAI เปรียบเทียบคำตอบเคียงข้างกันในหลายหน้าต่าง สร้างภาพ วิดีโอ และเพลงจากพื้นที่ทำงาน AI เดียว ใช้ฟรี',
        keywords:
            'AI แชท, ผู้ช่วย AI, แชทหลายโมเดล, แชทบอท AI, เปรียบเทียบโมเดล AI, แชท AI เคียงข้างกัน, ทางเลือก GPT, พื้นที่ทำงาน AI, WeryAI',
        og_title: 'AI แชท - ผู้ช่วยหลายโมเดล | WeryAI',
        og_description:
            'แชทกับโมเดล AI ชั้นนำและเปรียบเทียบคำตอบเคียงข้างกัน สร้างภาพ วิดีโอ และอื่นๆ ทดลองใช้ฟรีบน WeryAI',
        twitter_title: 'AI แชท - ผู้ช่วยหลายโมเดล | WeryAI',
        twitter_description:
            'แชทกับโมเดล AI ชั้นนำและเปรียบเทียบคำตอบเคียงข้างกัน สร้างภาพ วิดีโอ และอื่นๆ ทดลองใช้ฟรีบน WeryAI',
    },
}
